import { Language, useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import { useLocation } from 'react-router-dom';
import { useContext } from 'react';
import { ChangelogTab, ManageTokensTab, MarketSection, MarketTab, MyAssetsTab, RoutePath, ShopTab, StakingTab, generateRoutePath, } from '../../app/router/config';
import assetsIcon from '../../assets/images/icons/common/icon-assets-purple.png';
import changelogIcon from '../../assets/images/icons/common/icon-changelog-purple.png';
import ctaTokenIcon from '../../assets/images/icons/common/icon-cta-token.png';
import downloadIcon from '../../assets/images/icons/common/icon-download-purple.png';
import feedbackIcon from '../../assets/images/icons/common/icon-feedback-purple.png';
import landIcon from '../../assets/images/icons/common/icon-land-gold.png';
import marketIcon from '../../assets/images/icons/common/icon-market-purple.png';
import shopIcon from '../../assets/images/icons/common/icon-shop-purple.png';
import earnIcon from '../../assets/images/icons/common/icon-staking-purple.png';
import transferIcon from '../../assets/images/icons/common/icon-transaction-purple.png';
import tokensIcon from '../../assets/images/icons/common/icon-transfer-wallet-purple.png';
import wishlistIcon from '../../assets/images/icons/common/icon-wishlist-purple.png';
import srIcon from '../../assets/images/icons/rarities/icon-specialrare.png';
import ariseImage from '../../assets/images/market/market-arise.png';
import cardsImage from '../../assets/images/market/market-card.png';
import landsImage from '../../assets/images/market/market-land.png';
import mintPassesImage from '../../assets/images/market/market-mint-pass.png';
import { UserContext } from '../../context/user';
export function useHeaderContent() {
    var _a;
    var _b = useI18n(), t = _b.t, i18n = _b.i18n;
    var location = useLocation();
    var _c = useContext(UserContext), user = _c.user, localWalletAddress = _c.localWalletAddress;
    var websiteLanguageCode = i18n.language === Language.FR ? 'fr-fr' : 'en-us';
    var websiteLinksSections = [
        {
            label: t('header.website-links.gaming.label'),
            items: [
                {
                    label: t('header.website-links.gaming.tcg'),
                    path: "https://crosstheages.com/".concat(websiteLanguageCode, "/games/tcg"),
                },
                {
                    label: t('header.website-links.gaming.arise'),
                    path: "https://crosstheages.com/".concat(websiteLanguageCode, "/games/arise"),
                },
            ],
        },
        {
            label: t('header.website-links.universe.label'),
            items: [
                {
                    label: t('header.website-links.universe.lore'),
                    path: "https://crosstheages.com/".concat(websiteLanguageCode, "/universe/lore/"),
                },
                {
                    label: t('header.website-links.universe.merch'),
                    path: 'https://store.crosstheages.com',
                },
            ],
        },
        {
            label: t('header.website-links.who-we-are.label'),
            items: [
                {
                    label: t('header.website-links.who-we-are.about-us'),
                    path: "https://crosstheages.com/".concat(websiteLanguageCode, "/about-us"),
                },
                {
                    label: t('header.website-links.who-we-are.white-paper'),
                    path: 'https://whitepaper.crosstheages.com/',
                },
                {
                    label: t('header.website-links.who-we-are.lite-paper'),
                    path: 'https://crosstheages-webapp.cdn.prismic.io/crosstheages-webapp/Zz4FV68jQArT1FVH_crosstheages_litepaper_en.pdf',
                },
                {
                    label: t('header.website-links.who-we-are.join-us'),
                    path: 'https://emploi.afjv.com/annonces-societes/1971',
                },
            ],
        },
        {
            label: t('header.website-links.more.label'),
            items: [
                {
                    label: t('header.website-links.more.news'),
                    path: "https://crosstheages.com/".concat(websiteLanguageCode, "/news"),
                },
                {
                    label: t('header.website-links.more.events'),
                    path: "https://crosstheages.com/".concat(websiteLanguageCode, "/events"),
                },
                {
                    label: t('header.website-links.more.support'),
                    path: 'https://noria.crosstheages.com/hc/en-gb/requests/new',
                },
            ],
        },
    ];
    var shopLink = {
        label: t('header.nav-items.shop'),
        icon: shopIcon,
        selected: location.pathname.includes(RoutePath.SHOP.split('/')[1]),
        path: generateRoutePath(RoutePath.SHOP, { tab: ShopTab.CARDS }),
    };
    var marketLink = {
        label: t('header.nav-items.market'),
        icon: marketIcon,
        selected: location.pathname.includes(RoutePath.MARKET.split('/')[1]),
        path: generateRoutePath(RoutePath.MARKET, { section: MarketSection.CARDS, tab: MarketTab.PRODUCTS }),
        market: true,
    };
    var earnItems = {
        label: t('header.nav-items.earn'),
        icon: earnIcon,
        selected: location.pathname.includes(RoutePath.STAKING.split('/')[1]),
        path: generateRoutePath(RoutePath.STAKING, { tab: StakingTab.OVERVIEW }),
        disabled: !user,
        items: [
            {
                label: t('header.nav-items.staking'),
                path: generateRoutePath(RoutePath.STAKING, { tab: StakingTab.OVERVIEW }),
                icon: srIcon,
            },
            {
                label: t('header.nav-items.land-manager'),
                path: generateRoutePath(RoutePath.ROOT, {}),
                icon: landIcon,
                comingSoon: true,
            },
        ],
    };
    var tokensItems = {
        label: t('header.nav-items.token'),
        icon: tokensIcon,
        selected: location.pathname.includes(RoutePath.MANAGE_TOKENS.split('/')[1]),
        path: generateRoutePath(RoutePath.MANAGE_TOKENS, { tab: ManageTokensTab.BUY }),
        disabled: !user,
        items: [
            {
                label: t('header.nav-items.buy-cta-token'),
                path: generateRoutePath(RoutePath.MANAGE_TOKENS, { tab: ManageTokensTab.BUY }),
                icon: ctaTokenIcon,
            },
            {
                label: t('header.nav-items.transfer-tokens'),
                path: generateRoutePath(RoutePath.MANAGE_TOKENS, { tab: ManageTokensTab.TRANSFER }),
                note: 'CTA, USDC, IMX, ETH',
                icon: transferIcon,
            },
            {
                label: t('header.nav-items.bridge-cta-token'),
                path: generateRoutePath(RoutePath.MANAGE_TOKENS, { tab: ManageTokensTab.BRIDGE }),
                icon: ctaTokenIcon,
            },
        ],
    };
    if ((user === null || user === void 0 ? void 0 : user.ctaTokenClaimable) && user.ctaTokenClaimable.claimed === false) {
        (_a = tokensItems.items) === null || _a === void 0 ? void 0 : _a.push({
            label: t('header.nav-items.claim-token'),
            path: generateRoutePath(RoutePath.CLAIM_TOKEN, {}),
            icon: ctaTokenIcon,
        });
    }
    var moreItems = {
        label: t('header.nav-items.more'),
        selected: false,
        items: [
            {
                label: t('header.nav-items.download-tcg'),
                path: 'https://crosstheages.com/en-us/download/',
                icon: downloadIcon,
                external: true,
            },
            {
                label: t('header.nav-items.wishlist-arise'),
                path: 'https://store.epicgames.com/en-US/p/arise-fc3caa',
                icon: wishlistIcon,
                external: true,
            },
            {
                label: t('header.nav-items.changelog'),
                path: generateRoutePath(RoutePath.CHANGELOG, { tab: ChangelogTab.TCG }),
                icon: changelogIcon,
            },
            {
                label: t('header.nav-items.feedback'),
                path: generateRoutePath(RoutePath.FEEDBACK, {}),
                icon: feedbackIcon,
            },
        ],
    };
    var navItems = [shopLink, marketLink, earnItems, tokensItems, moreItems];
    var marketLinks = [
        {
            label: t('header.market-links.cards'),
            image: cardsImage,
            path: generateRoutePath(RoutePath.MARKET, { section: MarketSection.CARDS, tab: MarketTab.PRODUCTS }),
        },
        {
            label: t('header.market-links.mint-passes'),
            image: mintPassesImage,
            path: generateRoutePath(RoutePath.MARKET, { section: MarketSection.MINT_PASSES, tab: MarketTab.PRODUCTS }),
        },
        {
            label: t('header.market-links.arise'),
            image: ariseImage,
            path: generateRoutePath(RoutePath.MARKET, { section: MarketSection.ARISE, tab: MarketTab.PRODUCTS }),
        },
        {
            label: t('header.market-links.lands'),
            image: landsImage,
            path: generateRoutePath(RoutePath.MARKET, { section: MarketSection.LANDS, tab: MarketTab.PRODUCTS }),
            note: t('common.coming-soon'),
            comingSoon: true,
        },
    ];
    var myAssetsLinks = {
        label: t('header.right-links.my-assets'),
        icon: assetsIcon,
        selected: location.pathname.includes(RoutePath.MY_ASSETS.split('/')[1]) &&
            !location.pathname.includes(RoutePath.MY_ASSETS_FLEX),
        disabled: !(user === null || user === void 0 ? void 0 : user.mpcWalletAddress) && !(user === null || user === void 0 ? void 0 : user.magicLinkWalletAddress) && !(user === null || user === void 0 ? void 0 : user.coldWalletAddress) && !localWalletAddress,
        path: generateRoutePath(RoutePath.MY_ASSETS, { section: MarketSection.CARDS, tab: MyAssetsTab.ALL }),
        items: [
            {
                label: t('header.market-links.cards'),
                path: generateRoutePath(RoutePath.MY_ASSETS, { section: MarketSection.CARDS, tab: MyAssetsTab.ALL }),
            },
            {
                label: t('header.market-links.mint-passes'),
                path: generateRoutePath(RoutePath.MY_ASSETS, { section: MarketSection.MINT_PASSES, tab: MyAssetsTab.ALL }),
            },
            {
                label: t('header.market-links.arise'),
                path: generateRoutePath(RoutePath.MY_ASSETS, { section: MarketSection.ARISE, tab: MyAssetsTab.ALL }),
            },
            {
                label: t('header.market-links.lands'),
                path: generateRoutePath(RoutePath.MY_ASSETS, { section: MarketSection.LANDS, tab: MyAssetsTab.ALL }),
                comingSoon: true,
            },
        ],
    };
    var reverseLink = {
        label: t('header.right-links.reverse'),
        selected: false,
        path: generateRoutePath(RoutePath.ROOT, {}),
        lowercase: true,
        disabled: true,
    };
    var rightLinks = [reverseLink, myAssetsLinks];
    return {
        websiteLinksSections: websiteLinksSections,
        navItems: navItems.filter(function (item) { return !item.disabled; }),
        shopLink: shopLink,
        myAssetsLinks: myAssetsLinks,
        marketLink: marketLink,
        marketLinks: marketLinks,
        earnItems: earnItems,
        tokensItems: tokensItems,
        moreItems: moreItems,
        reverseLink: reverseLink,
        rightLinks: rightLinks.filter(function (item) { return !item.disabled; }),
    };
}
